module.exports = __webpack_public_path__ + "img/goodsrope2.068dca2b.png";